// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"922eda4a","790":"9f56e0e0"}[chunkId] + ".chunk.js";
};